import {
  CURRENT_QUEUE_NEW_STATUS,
  EMPTY_QUEUES_LIST,
  LOAD_QUEUES_SUCCESS,
  PAUSE_WARM,
  RESUME_WARM,
  SET_CURRENT_QUEUE,
  SET_QUEUE_PAGE,
  SET_QUEUE_PAGE_MONTH,
  SET_QUEUE_PAGE_YEAR,
  STOP_WARM,
} from './action-types'

import { firebaseDb } from 'modules/firebase'


let queueRef = null;

export function loadQueues(siteId) {
  return dispatch => {
    if (queueRef !== null) {
      dispatch({ type: EMPTY_QUEUES_LIST })
      if (queueRef.hasOwnProperty('off')) {
        queueRef.off()
      }
    }
    queueRef = firebaseDb.ref(`/queues/${siteId}`)

    queueRef.once('value', snapshots => {
      let records = []
      let data = snapshots.val() || []

      Object.keys(data).forEach(key => {
        let record = data[key]
        record.key = key
        records.push(record)
      })

      dispatch({
        type: LOAD_QUEUES_SUCCESS,
        payload: records,
        site: siteId,
      })
    })
  }
}

let currentQueueStatusRef = null

export function setCurrentQueue(siteId, queue) {
  return dispatch => {
    dispatch({
      type: SET_CURRENT_QUEUE,
      payload: queue,
    })

    if (currentQueueStatusRef && currentQueueStatusRef.hasOwnProperty('off')) {
      currentQueueStatusRef.off()
    }

    currentQueueStatusRef = firebaseDb.ref(`/queues/${siteId}/${queue}`)

    currentQueueStatusRef.on('child_added', (snap, prevKey) => {
      dispatch({
        type: CURRENT_QUEUE_NEW_STATUS,
        payload: { ...snap.val(), prevKey },
        key: snap.key,
        queueId: queue,
      })
    })
  }
}

export const pause = queue => ({ type: PAUSE_WARM, payload: queue })
export const resume = queue => ({ type: RESUME_WARM, payload: queue })
export const stop = queue => ({ type: STOP_WARM, payload: queue })

/**
 * Create action for setting active queues page.
 *
 * @param {string} date - month | year | both
 * @param {number|object} page
 * @returns {object} {{type, payload: *}} - redux action
 */
export const setQueuePage = (date, page) => {
  let actionType = SET_QUEUE_PAGE;
  let payload;

  if (date === 'year') {
    actionType = SET_QUEUE_PAGE_YEAR;
  } else if (date === 'month') {
    actionType = SET_QUEUE_PAGE_MONTH;
  }

  if (date === 'year' || date === 'month') {
    payload = { [date]: page }
  } else {
    payload = page
  }

  return {
    type: actionType,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/modules/queues/actions.js